import ActivityCard from "../../../../Core/Activity/ActivityCard";
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Tab2Table1 from "./Tab2Table1";
import Tab2Table2 from "./Tab2Table2";

const Tab2 = ({
  ItemCode,
  Shelf_Life_In_Days,
  End_of_Life,
  DefaultMaterialRequestType,
  ValuationMethod,
  Brand,
  WarrantyPeriod,
  WeightPerUnit,
  WeightUOM,
AllowNegativeStock,
setselected_barcodes_item_data,
selected_barcodes_item_data,
setselected_auto_re_order_item_data,
selected_auto_re_order_item_data
}) => {
  

    
  return (
    <>
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Inventory Settings</p>
      </div>
      <div className="col-3 ">
        <div className="mb-3">
          <Input
          readOnly
            id="Shelf_Life_In_Days"
            label="Shelf Life In Days"
            style={{ height: "30px", }}
            value={Shelf_Life_In_Days.Shelf_Life_In_Days}
            onChange={(e) => Shelf_Life_In_Days.setShelf_Life_In_Days(e.target.value)}
          />
         
        </div>
      </div>
      <div className="col-3 ">
        <div className="mb-3">
          <Date
          readOnly
              style={{
  height: "30px",
  border: End_of_Life?.Error ? "1px solid red" : "",
}}

              id="End_of_Life"
              label="End of Life"
              value={End_of_Life.End_of_Life}
              onChange={(e) => End_of_Life.setEnd_of_Life(e.target.value)}
            />
          
         
        </div>
      </div>

     

       <div className="col-3 ">
        <div className="mb-3">
          <Input  label="Default Material Request Type" readOnly value={DefaultMaterialRequestType.DefaultMaterialRequestType} style={{ height: '38px' }} />
           
          
        </div>
      </div>

       <div className="col-3 ">
        <div className="mb-3">
          <Input  label="Valuation Method" readOnly value={ValuationMethod.ValuationMethod} style={{ height: '38px' }} />
           
         

        </div>
      </div>
      

      <div className="col-4 ">
        <div className="mb-3">
          <Input
          style={{
              height: "30px",
              border: WarrantyPeriod?.Error ? "1px solid red" : "",
            }}
            readOnly
            id="WarrantyPeriod"
            label="Warranty Period (in days)"
            value={WarrantyPeriod.WarrantyPeriod}
            onChange={(e) => WarrantyPeriod.setWarrantyPeriod(e.target.value)}
          />
          
        </div>
      </div>

      <div className="col-4 ">
        <div className="mb-3">
             <Input
             readOnly
          style={{
              height: "30px",
              border: WeightPerUnit?.Error ? "1px solid red" : "",
            }}
            label="Weight Per Unit"
             
            value={WeightPerUnit.WeightPerUnit}
            onChange={(e) =>
              WeightPerUnit?.setWeightPerUnit?.(e.target.value)
              
            }
          />
        </div>
      </div>
      <div className="col-4 ">
        <div className="mb-3">
            <Input  label="Weight UOM" readOnly value={WeightUOM.select_WeightUOM} style={{ height: '38px' }} />
           
         
          

        </div>
      </div>
     
 <div className="col-4 ">
        <div className="mb-3">
        
 <Checkbox
            id="AllowNegativeStock"
            label="Allow Negative Stock"
            value={AllowNegativeStock?.AllowNegativeStock || false}
            onChange={(val) => AllowNegativeStock?.setAllowNegativeStock?.(val)}
            disabled={true}
          />

        </div>
      </div>

    </div>

    


         
          <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Barcodes</p>
      </div>
      
         
          <Tab2Table1 setselected_barcodes_item_data={setselected_barcodes_item_data}  selected_barcodes_item_data={selected_barcodes_item_data}/>
          </div>
          <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Auto re-order</p>
      </div>
      
         <Tab2Table2 setselected_auto_re_order_item_data={setselected_auto_re_order_item_data} selected_auto_re_order_item_data={selected_auto_re_order_item_data} />
          </div>

          <div>
              <ActivityCard doctype={'Item'} docname={ItemCode.ItemCode} />
          </div>
          </>
  );
};

export default Tab2;
